import { Order } from "../../../types";

/** `null` = allowed; a string = locked, and why (shown as a tooltip). */
export type LockReason = string | null;

export interface QuickEditRules {
    /** Courier and order channel. */
    delivery: LockReason;
    /** Delivery charge — changes the total. */
    charge: LockReason;
    /** Delivery cost (what we pay the courier) — never changes the total. */
    cost: LockReason;
    items: LockReason;
}

/**
 * What the drawer's quick edits may change. Mirrors the server's own rules
 * (it enforces them regardless) so staff see why a control is off instead
 * of hitting an error:
 *  - cancelled orders are locked;
 *  - a return adjusts the total directly, so items and the charge can't be
 *    re-derived afterwards;
 *  - items on a delivered order are Owner-only.
 */
export function getQuickEditRules(
    order: Pick<Order, "status">,
    { isOwner, hasReturns }: { isOwner: boolean; hasReturns: boolean },
): QuickEditRules {
    if (order.status === "CANCELLED") {
        const reason = "Cancelled orders can't be changed.";
        return { delivery: reason, charge: reason, cost: reason, items: reason };
    }
    const returnsLock = hasReturns
        ? "This order has returns, so its items and delivery charge can't change."
        : null;
    return {
        delivery: null,
        charge: returnsLock,
        cost: null,
        items:
            returnsLock ??
            (order.status === "DELIVERED" && !isOwner
                ? "Only the Owner can change items on a delivered order."
                : null),
    };
}
